export const propertyBlacklist = ['OGR_STYLE'];
